import axios from 'axios';
import entityStore from '@/store/entityStore';
import { restEndpoint } from '../config.json';
import userAuthStore from '../store/userAuthStore';

const userApi = {};

// check the status code of the received response
const checkStatusCode = (statusCode) => {
  if (statusCode === 400) {
    userAuthStore.logOut(true);
  }
};

const responseReader = (callback) => {
  const myFunc = (response) => {
    checkStatusCode(response.data.status.code);
    callback(response);
  };
  return myFunc;
};

const downloadPdf = (data) => {
  if (data.data.success) {
    const link = document.createElement('a');
    link.download = true;
    link.href = data.data.url;

    document.body.appendChild(link);

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // opens new tab.. not sure if it'll work when using this as a webview in the apps
    if (iOS) {
      link.click();
    } else {
      // Revert to only this one V, if it doesn't work anymore
      const popUp = window.open(link);
    }
    if (popUp === null || typeof popUp === 'undefined') {
      alert('Het downloaden van dit bestand wordt geblokkeerd. Zorg ervoor dat de pop-ups niet geblokkeerd worden en probeer het daarna opnieuw.');
    }
    document.body.removeChild(link);
  } else {
    alert('Dit bestand kan momenteel niet gedownload worden, probeer het later opnieuw of neem contact met ons op.');
  }
};

// SAVE THIS CODE JUST INCASE WE NEED IT AGAIN

// var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// var ua = navigator.userAgent.toLowerCase();
// var isAndroid = ua.indexOf("android") > -1;

// if(iOS || isAndroid) {
//   link.click();
// } else {
//   window.open(data.data.url);
// }

export default userApi;

// authentication user
userApi.authUser = (username, password, callback) => {
  axios.post(`${restEndpoint}/auth-user`, {
    email: username,
    resNo: password,
    entityId: entityStore.state.id,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getUser = (callback) => {
  axios.post(`${restEndpoint}/user`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getUpcomingReservation = (callback) => {
  axios.post(`${restEndpoint}/upcoming-reservation`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getUpcomingReservations = (callback) => {
  axios.post(`${restEndpoint}/upcoming-reservations`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getPastReservations = (callback) => {
  axios.post(`${restEndpoint}/past-reservations`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getReservation = (id, callback) => {
  axios.post(`${restEndpoint}/reservation/${id}`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getInvoice = (id, callback) => {
  axios.post(`${restEndpoint}/reservation/${id}/invoice`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getVouchers = (id, callback) => {
  axios.post(`${restEndpoint}/reservation/${id}/vouchers`, {
    token: userAuthStore.state.token,
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.downloadVoucher = (id, voucher, name) => {
  const data = Object.assign({ token: userAuthStore.state.token }, voucher);
  axios({
    url: `${restEndpoint}/reservation/${id}/download-voucher`,
    method: 'POST',
    data,
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};

userApi.downloadInvoice = (id, invoiceId) => {
  axios({
    url: `${restEndpoint}/reservation/${id}/download-invoice`,
    method: 'POST',
    data: {
      invoice_id: invoiceId,
      token: userAuthStore.state.token,
    },
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};

userApi.downloadInvoiceAttachment = (id) => {
  axios({
    url: `${restEndpoint}/reservation/${id}/download-invoice-attachment`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};

userApi.getParticipants = (id, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${id}/participants`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getReservationComponents = (reservationId, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/components`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.downloadTravelDocument = (reservationId, document) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/travel-document/download`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
      fileName: document.name,
    },
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};

userApi.downloadPassengerDocument = (reservationId, passengerId, document) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/passenger/${passengerId}/document/download`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
      fileName: document.name,
    },
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};

userApi.downloadParticipantsList = (reservationId) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/participants/download`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then((response) => {
    downloadPdf(response.data);
  });
};


userApi.getInsurances = (reservationId, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/insurances`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getGeneralInfo = (reservationId, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/general-info`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};


userApi.getTravelDocuments = (reservationId, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/travel-documents`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.getPassengers = (reservationId, callback) => {
  axios({
    url: `${restEndpoint}/reservation/${reservationId}/passengers`,
    method: 'POST',
    data: {
      token: userAuthStore.state.token,
    },
  })
  .then(responseReader((response) => {
    callback(response.data.data);
  }));
};

userApi.updatePassengerPassport = (passengerId, data, callback, errorCallback) => {
  const dataCopy = Object.assign({ token: userAuthStore.state.token }, data);

  axios({
    url: `${restEndpoint}/passenger/${passengerId}/update/passport`,
    method: 'POST',
    data: dataCopy,
  }).then((response) => {
    callback(response.data.data);
  }).catch((error) => {
    if (errorCallback) {
      errorCallback(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/userApi.js